const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"edb25aceb22277442fb520de470d269bc1fd4d0b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["capra-designs@long-forme"]={id:"edb25aceb22277442fb520de470d269bc1fd4d0b"};
      